import { Button, Typography } from 'antd';
import { ArrowRightOutlined, CheckOutlined } from '@ant-design/icons';
import { useIsMobile } from '@/context/IsMobileContext.tsx';
import { SURFACE } from '@/styles/surfaces.ts';
import { WizardProgress } from './WizardProgress.tsx';

const { Title, Text } = Typography;

interface IWizardSuccessStepProps {
  firstName: string;
  onFinish: () => void;
}

export const WizardSuccessStep = ({ firstName, onFinish }: IWizardSuccessStepProps) => {
  const { isMobile } = useIsMobile();

  return (
    <div style={{ padding: isMobile ? '22px 20px 26px' : '30px 34px 34px' }}>
      <WizardProgress current={2} />

      <div style={{ textAlign: 'center', padding: isMobile ? '12px 0 4px' : '20px 0 8px' }}>
        <div
          style={{
            width: isMobile ? 56 : 64,
            height: isMobile ? 56 : 64,
            borderRadius: '50%',
            background: 'rgba(22, 163, 74, 0.1)',
            border: '1px solid rgba(22, 163, 74, 0.2)',
            color: '#16a34a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: isMobile ? 24 : 28,
            margin: '0 auto',
          }}
        >
          <CheckOutlined />
        </div>
        <Title
          level={isMobile ? 4 : 3}
          style={{
            marginTop: 18,
            marginBottom: 8,
            color: SURFACE.text.strong,
            letterSpacing: '-0.02em',
          }}
        >
          You're all set{firstName ? `, ${firstName}` : ''}
        </Title>
        <Text
          style={{
            display: 'block',
            marginBottom: isMobile ? 24 : 30,
            fontSize: isMobile ? 14 : 15,
            color: SURFACE.text.muted,
            lineHeight: 1.6,
            maxWidth: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          Next up: a quick property survey so we can build your personalized plan.
        </Text>
        <Button
          type='primary'
          block
          icon={<ArrowRightOutlined />}
          iconPosition='end'
          onClick={onFinish}
        >
          Start Property Survey
        </Button>
      </div>
    </div>
  );
};
